(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airdoctor-space-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 750px)');
    /** @type {Map<string, AbortController>} */
    const controllersBySectionId = new Map();

    /**
     * @param {Element} section
     * @returns {string}
     */
    const getSectionKey = (section) => {
      return section.closest('.shopify-section')?.id || section.id || 'airdoctor-space-finder';
    };

    /**
     * @param {Element} section
     * @returns {boolean}
     */
    const isCarouselActive = (section) => {
      if (desktopQuery.matches) {
        return section.classList.contains('airdoctor-space-finder--desktop-carousel');
      }

      return section.classList.contains('airdoctor-space-finder--mobile-carousel');
    };

    const destroySection = (section) => {
      const key = getSectionKey(section);
      const controller = controllersBySectionId.get(key);

      if (controller) {
        controller.abort();
        controllersBySectionId.delete(key);
      }

      delete section.dataset.spaceFinderBound;
    };

    /**
     * @param {Element} section
     */
    const initSection = (section) => {
      if (section.dataset.spaceFinderBound === 'true') return;

      const cards = section.querySelector('[data-space-finder-cards]');
      const prevButton = section.querySelector('[data-space-finder-prev]');
      const nextButton = section.querySelector('[data-space-finder-next]');

      if (!cards || !prevButton || !nextButton) return;

      destroySection(section);

      const controller = new AbortController();
      const { signal } = controller;

      controllersBySectionId.set(getSectionKey(section), controller);
      section.dataset.spaceFinderBound = 'true';

      const getStep = () => {
        const firstCard = cards.querySelector('.airdoctor-space-finder__card');

        if (!firstCard) return 320;

        const styles = window.getComputedStyle(cards);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;

        return Math.round(firstCard.getBoundingClientRect().width + gap);
      };

      const updateButtons = () => {
        if (signal.aborted) return;

        if (!isCarouselActive(section)) {
          prevButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        const canScroll = cards.scrollWidth > cards.clientWidth + 2;

        if (!canScroll) {
          prevButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        prevButton.disabled = cards.scrollLeft <= 2;
        nextButton.disabled = cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 2;
      };

      let scrollRaf = 0;

      const scheduleUpdate = () => {
        if (scrollRaf) return;

        scrollRaf = requestAnimationFrame(() => {
          scrollRaf = 0;
          updateButtons();
        });
      };

      signal.addEventListener('abort', () => {
        if (scrollRaf) {
          cancelAnimationFrame(scrollRaf);
          scrollRaf = 0;
        }
      });

      prevButton.addEventListener(
        'click',
        () => {
          if (!isCarouselActive(section)) return;

          cards.scrollBy({ left: -getStep(), behavior: 'smooth' });
        },
        { signal }
      );

      nextButton.addEventListener(
        'click',
        () => {
          if (!isCarouselActive(section)) return;

          cards.scrollBy({ left: getStep(), behavior: 'smooth' });
        },
        { signal }
      );

      // Off-screen cards stay in the a11y tree and Tab order (never `inert`, which
      // hid all but the 2-3 visible purifiers from NVDA); focusing one scrolls it
      // into view instead (WCAG 2.4.11).
      cards.addEventListener(
        'focusin',
        (event) => {
          if (!isCarouselActive(section) || !(event.target instanceof Element)) return;

          event.target
            .closest('.airdoctor-space-finder__card')
            ?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        },
        { signal }
      );

      cards.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
      window.addEventListener('resize', scheduleUpdate, { signal });
      desktopQuery.addEventListener('change', scheduleUpdate, { signal });

      const images = cards.querySelectorAll('img');

      for (const image of images) {
        image.addEventListener('load', updateButtons, { once: true, signal });
      }

      window.addEventListener('load', updateButtons, { once: true, signal });
      updateButtons();
    };

    /**
     * @param {EventTarget | null} target
     * @returns {Element | null}
     */
    const findCarouselSection = (target) => {
      if (!(target instanceof Element)) return null;

      if (
        target.matches(
          '.airdoctor-space-finder--mobile-carousel, .airdoctor-space-finder--desktop-carousel'
        )
      ) {
        return target;
      }

      return target.querySelector(
        '.airdoctor-space-finder--mobile-carousel, .airdoctor-space-finder--desktop-carousel'
      );
    };

    const initAll = () => {
      const sections = document.querySelectorAll(
        '.airdoctor-space-finder--mobile-carousel, .airdoctor-space-finder--desktop-carousel'
      );

      for (const section of sections) {
        initSection(section);
      }
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const section = findCarouselSection(event.target);

      if (section) {
        destroySection(section);
        initSection(section);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = findCarouselSection(event.target);

      if (section) {
        destroySection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-airdoctor-protects"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ad-protection');

    sections.forEach((section) => {
      const track = section.querySelector('[data-protection-slider]');
      const cards = section.querySelector('.ad-protection__cards');
      const prevButton = section.querySelector('[data-protection-prev]');
      const nextButton = section.querySelector('[data-protection-next]');

      if (!track || !cards || !prevButton || !nextButton) return;

      const step = () => {
        const firstCard = cards.querySelector('.ad-protection__card');
        if (!firstCard) return Math.max(Math.round(track.clientWidth * 0.85), 260);

        const styles = window.getComputedStyle(cards);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return Math.round(firstCard.getBoundingClientRect().width + gap);
      };
      const canScroll = () => cards.scrollWidth > cards.clientWidth + 2;
      const desktopQuery = window.matchMedia('(min-width: 990px)');

      // Announce "carousel" only while the cards actually scroll (below 990px).
      const syncRoleDescription = () => {
        if (desktopQuery.matches) {
          track.removeAttribute('aria-roledescription');
        } else {
          track.setAttribute('aria-roledescription', track.dataset.carouselRoledescription || 'carousel');
        }
      };

      const updateButtons = () => {
        if (!canScroll()) {
          prevButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        prevButton.disabled = cards.scrollLeft <= 2;
        nextButton.disabled = cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 2;
      };

      prevButton.addEventListener('click', () => {
        cards.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        cards.scrollBy({ left: step(), behavior: 'smooth' });
      });

      cards.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      desktopQuery.addEventListener('change', syncRoleDescription);
      syncRoleDescription();
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const horizontalObservers = new WeakMap();

  const normalizeHorizontalProductCards = (root = document) => {
    const cards = root.querySelectorAll('.product-grid--horizontal .product-card__content--horizontal');

    cards.forEach((card) => {
      const media = card.firstElementChild;
      if (!media) return;

      let textWrapper = card.querySelector(':scope > .product-card__text');
      if (!textWrapper) {
        textWrapper = document.createElement('div');
        textWrapper.className = 'product-card__text';
      }

      const textNodes = Array.from(card.children).filter((child) => child !== media && child !== textWrapper);
      textNodes.forEach((child) => textWrapper.appendChild(child));

      if (!textWrapper.childElementCount) {
        if (textWrapper.parentNode) textWrapper.remove();
        return;
      }

      if (textWrapper.parentNode !== card) {
        card.appendChild(textWrapper);
      }

      if (media.nextElementSibling !== textWrapper) {
        card.insertBefore(textWrapper, media.nextSibling);
      }
    });
  };

  const scheduleNormalize = (list) => {
    if (list.dataset.horizontalNormalizeQueued === 'true') return;
    list.dataset.horizontalNormalizeQueued = 'true';
    requestAnimationFrame(() => {
      list.dataset.horizontalNormalizeQueued = 'false';
      normalizeHorizontalProductCards(list);
      if (list.dataset.horizontalNormalized === 'false') {
        list.dataset.horizontalNormalized = 'true';
      }
    });
  };

  const observeHorizontalList = (list) => {
    if (horizontalObservers.has(list)) return;

    const observer = new MutationObserver(() => {
      scheduleNormalize(list);
    });

    observer.observe(list, { childList: true, subtree: true });
    horizontalObservers.set(list, observer);
  };

  const teardownHorizontalObservers = (scope = document) => {
    const lists = scope.matches?.('results-list.product-grid--horizontal')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('results-list.product-grid--horizontal') || []);

    lists.forEach((list) => {
      const observer = horizontalObservers.get(list);
      if (observer) {
        observer.disconnect();
        horizontalObservers.delete(list);
      }
    });
  };

  const initHorizontalProductCards = (scope = document) => {
    const lists = scope.matches?.('results-list.product-grid--horizontal')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('results-list.product-grid--horizontal') || []);

    lists.forEach((list) => {
      normalizeHorizontalProductCards(list);
      if (list.dataset.horizontalNormalized === 'false') {
        list.dataset.horizontalNormalized = 'true';
      }
      observeHorizontalList(list);
    });
  };

  const scrollToHashCard = () => {
    if (!url.hash) return;
    const card = document.getElementById(url.hash.slice(1));
    if (!card) return;
    card.scrollIntoView({ behavior: 'instant' });
  };

  const initHorizontalProductCardsWhenReady = (framesRemaining = 60) => {
    const hasHorizontalList = document.querySelector('results-list.product-grid--horizontal');
    if (hasHorizontalList) {
      initHorizontalProductCards();
      scrollToHashCard();
      return;
    }

    if (framesRemaining <= 0) {
      scrollToHashCard();
      return;
    }

    requestAnimationFrame(() => {
      initHorizontalProductCardsWhenReady(framesRemaining - 1);
    });
  };

  initHorizontalProductCardsWhenReady();

  document.addEventListener('shopify:section:load', (event) => {
    initHorizontalProductCards(event.target);
  });

  document.addEventListener('shopify:section:reorder', (event) => {
    initHorizontalProductCards(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    teardownHorizontalObservers(event.target);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-get-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-get-app]');

    sections.forEach((section) => {
      const redirectingState = section.querySelector('[data-get-app-redirecting]');
      const desktopState = section.querySelector('[data-get-app-desktop]');
      const storeName = section.querySelector('[data-get-app-store-name]');
      const storeLink = section.querySelector('[data-get-app-store-link]');
      const storeLinkLabel = section.querySelector('[data-get-app-store-link-label]');
      const appStoreUrl = section.dataset.appStoreUrl || '';
      const playStoreUrl = section.dataset.playStoreUrl || '';

      if (!redirectingState || !desktopState) return;

      const setState = (stateName) => {
        redirectingState.hidden = stateName !== 'redirecting';
        desktopState.hidden = stateName !== 'desktop';
        section.dataset.getAppState = stateName;
      };

      const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
      const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isAndroid = /android/i.test(userAgent);

      if (!isIos && !isAndroid) {
        setState('desktop');
        return;
      }

      const isAppleStore = isIos;
      const destinationUrl = isAppleStore ? appStoreUrl : playStoreUrl;
      const destinationName = isAppleStore ? 'App Store' : 'Google Play Store';

      if (storeName) {
        storeName.textContent = destinationName;
      }

      if (storeLink) {
        storeLink.href = destinationUrl;
      }

      if (storeLinkLabel) {
        storeLinkLabel.textContent = `open the ${destinationName} now`;
      }

      setState('redirecting');
      if (destinationUrl) {
        window.location.replace(destinationUrl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-results-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    const initSection = (section) => {
      if (section.dataset.realResultsBound == 'true') return;

      section.dataset.realResultsBound = 'true';
      const cards = section.querySelector('[data-real-results-cards]');
      const prevButton = section.querySelector('[data-real-results-prev]');
      const nextButton = section.querySelector('[data-real-results-next]');

      if (!cards || !prevButton || !nextButton) return;

      const getStep = () => {
        const firstCard = cards.querySelector('.ad-real-results__card');
        if (!firstCard) return 320;

        const styles = window.getComputedStyle(cards);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return Math.round(firstCard.getBoundingClientRect().width + gap);
      };

      // aria-disabled, not disabled: a disabled button leaves the tab order (Previous
      // was unreachable at the start) and disabling the focused button at either end
      // drops keyboard focus to <body>.
      const setDisabled = (button, isDisabled) => {
        button.setAttribute('aria-disabled', String(isDisabled));
      };

      const updateButtons = () => {
        const canScroll = cards.scrollWidth > cards.clientWidth + 2;

        if (!canScroll) {
          setDisabled(prevButton, true);
          setDisabled(nextButton, true);
          return;
        }

        setDisabled(prevButton, cards.scrollLeft <= 2);
        setDisabled(nextButton, cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 2);
      };

      prevButton.addEventListener('click', () => {
        if (prevButton.getAttribute('aria-disabled') == 'true') return;
        cards.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        if (nextButton.getAttribute('aria-disabled') == 'true') return;
        cards.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      cards.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      desktopQuery.addEventListener('change', updateButtons);

      const images = cards.querySelectorAll('img');
      for (const image of images) {
        image.addEventListener('load', updateButtons, { once: true });
      }

      window.addEventListener('load', updateButtons, { once: true });
      updateButtons();
    };

    const initAll = () => {
      const sections = document.querySelectorAll('.ad-real-results');
      for (const section of sections) {
        initSection(section);
      }
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.closest('.ad-real-results');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
